import * as React from 'react';
import {withStyles,
  WithStyles,
  StyleRules,
  ClassNameMap
} from '@mui/styles';
import {Theme} from '@mui/styles';
import Snackbar from '@mui/material/Snackbar';
import {Icon} from '@mui/material';
import {IconButton} from '@mui/material';
import {Button} from '@mui/material';
import {grey, red} from '@mui/material/colors';
import {APIError} from '~common/lib/types';

const styles = (theme: Theme): StyleRules => ({
  container: {
    width: '100%'
  },
  snackbar: {
    width: '600px', 
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  errorView: {
    border: '1px solid #990000',
    padding: '0px 15px 15px 15px'
  },
  snackbarContent: {
    width: '100%',
    backgroundColor: red[500] + ' !important',
    color: grey[100] + ' !important',
  },
  // TODO: jdouglas - discuss the use of colors
  detailsButton: {
    marginTop: theme.spacing(0.25),
    color: grey[100]
  },
  close: {
    width: theme.spacing(4),
    height: theme.spacing(4),
  }
});

interface Props extends React.HTMLProps<HTMLDivElement> {
  error: APIError | string | null | undefined;
  autoHideDuration?: number;
  onClose?: Function;
  mode?: 'inline' | 'toaster';
}

type State = {
  open: boolean;
  error: APIError | undefined | string | null;
};

class ErrorView extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {});
    var err: APIError | undefined;
    if (props.error) {
      if (typeof props.error == 'string') {
        err = new APIError('general', props.error);
      } else {
        err = props.error;
      }
      this.state = {error: err, open: true};
    } else {
      this.state = {
        error: new APIError('general', 'unspecified error'),
        open: false
      };
    }
  }

  UNSAFE_componentWillReceiveProps(props: any) {
    var err: APIError | undefined | string;
    if (props.error) {
      if (typeof props.error == 'string') {
        err = new APIError('general', props.error as string);
      } else {
        err = props.error;
      }
      this.setState({error: err, open: true});
    } else {
      this.setState({error: 'unspecified error', open: false});
      // this.state = {error: 'unspecified error', open: false};
    }
  }
 componentDidMount() {
    const {props} = this;
    var err: APIError | undefined;
    if (props.error) {
      if (typeof props.error == 'string') {
        err = new APIError('general', props.error);
      } else {
        err = props.error;
      }
      this.setState({error: err, open: true});
    } else {
      this.setState({error: err, open: false});
    }
  }

  handleClose = (event: any) => {
    this.setState({open: false});
    if (this.props.onClose) {
      this.props.onClose();
    }
  };

  handleCloseRequest = (event: any, reason: string) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({open: false});
    if (this.props.onClose) {
      this.props.onClose();
    }
  };

  render() {
    const {classes}: {classes: ClassNameMap} = this.props;
    const {autoHideDuration} = this.props;
    const {error, open} = this.state;

    const mode = this.props.mode || 'toaster';

    let errMsg = 'Unspecified Error';
    if (error && error.hasOwnProperty("message")) {
      errMsg = error["message"];
    }

    if(error && error.response && error.response.text){
      errMsg = error.response.text
    }

    switch (mode) {
      case 'inline':
        return (
          <div className={classes.errorView}>
            <h3>Error</h3>
            {errMsg}
          </div>
        );

        break;

      default:
        // console.log("error", error)
        if (!error || (!error["message"] && !error["template"])) {
          return null;
        }
        // TODO: jdouglas - Toastr based implementation for IE 10?
        var action: any;
        if (error && error["details"] && true) {
          // TODO: jdouglas - Copy instead of details.
          action = [
            // <Button
            //   key="undo"
            //   className={classes.detailsButton}
            //   variant="flat"
            //   onClick={this.handleClose}>
            //   Copy
            // </Button>,
            <IconButton
              key="close"
              aria-label="Close"
              color="inherit"
              size="large"
              className={classes.close}
              onClick={this.handleClose}>
              <Icon>close</Icon>
            </IconButton>
          ];
        } else {
          action = (
            <div>
              <IconButton
                key="close"
                aria-label="Close"
                color="inherit"
                size="large"
                className={classes.close}
                onClick={this.handleClose}>
                <Icon>close</Icon>
              </IconButton>
            </div>
          );
        }

        var message;
        if (error["template"]) {
          message = <div dangerouslySetInnerHTML={{__html: error["template"]}} />;
        } else {
          message = <span id="message-id">{errMsg}</span>;
        }
        return (
          <div id="error-view" className={classes.container}>
            <Snackbar
              className={classes.snackbar}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'center'
              }}
              open={open}
              autoHideDuration={
                autoHideDuration !== undefined ? autoHideDuration : 5000
              }
              ContentProps={{
                'aria-describedby': 'message-id',
                className: classes.snackbarContent
              }}
              onClose={this.handleCloseRequest}
              message={message}
              action={action}
            />
          </div>
        );
    }
  }
}

export default withStyles(styles)(ErrorView);
